import {ACCOUNT_TABS} from '../../../constants'

// ------------------------------------
// Constants
// ------------------------------------
const CHANGE_ACCOUNT_TAB = 'CHANGE_ACCOUNT_TAB';

// ------------------------------------
// Actions
// ------------------------------------
function changeAccountTab(value = '') {
  return {
    type    : CHANGE_ACCOUNT_TAB,
    payload : value
  }
}

export {
  changeAccountTab
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CHANGE_ACCOUNT_TAB]  : (state, action) => action.payload,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = ACCOUNT_TABS.TRANSACTIONS;

export default function accountReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/layouts/Content/modules/account.js